export class CustomerCareError extends Error {}
